import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ index, label }) => (
  <div className="flex items-center gap-4">
    <span className="font-mono text-xs font-semibold tracking-[0.22em] text-terra">
      {String(index).padStart(2, "0")}
    </span>
    <span className="h-px w-10 bg-terra/60" />
    <span className="eyebrow">{label}</span>
  </div>
);

export const scrollToId = (hash) => (e) => {
  if (e) e.preventDefault();
  if (window.__lenis) {
    window.__lenis.scrollTo(hash, { offset: -70, duration: 1.4 });
  } else {
    document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
  }
};
